import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "max-lg:hidden" }
const _hoisted_2 = {
  key: 0,
  class: "relative"
}
const _hoisted_3 = { class: "absolute top-2 left-1/2 -translate-x-1/2 bg-tile p-4 rounded-lg border border-tile-border w-110 space-y-4" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "whitespace-nowrap truncate mt-2" }
const _hoisted_6 = ["href", "textContent"]

import {computed, ref, watch} from "vue";
import {SearchItem, SearchItemType} from "../../../../../Application/Navigation/Port/SearchPrompt";
import {useClickOutside} from "../../../Helper/clickOutside";
import {useNavigationStore} from "../navigationStore";
import {useNavigationService} from "../vue";

interface GroupedByType {
  [type: SearchItemType]: SearchItem[];
}

export default /*@__PURE__*/_defineComponent({
  __name: 'SearchField',
  setup(__props) {

const service = useNavigationService();
const store = useNavigationStore();

const searchPhrase = ref<string>('');

function search(): void {
  service.search(searchPhrase.value);
  searchCloseForced.value = false;
}

const searchCloseForced = ref<boolean>(false);
const clickOutside = useClickOutside(false);
const searchHasItems = computed<boolean>(() => {
  return store.searchItems.length > 0;
});

watch(searchHasItems, (newValue: boolean): void => {
  if (newValue) {
    clickOutside.addClickListener(() => searchCloseForced.value = true);
  } else {
    clickOutside.removeAll();
  }
});

const searchItemsVisible = computed<boolean>(() => {
  return searchHasItems.value && !searchCloseForced.value;
});

function searchItemTypeTitle(type: SearchItemType): string {
  const titles: Record<SearchItemType, string> = {
    jobOffer: 'Oferty pracy',
    user: 'Użytkownicy',
    topic: 'Wątki',
    article: 'Artykuły',
  };
  return titles[type];
}

const searchItemsGroupedByType = computed<GroupedByType>(() => {
  return Object.groupBy(store.searchItems, searchItem => searchItem.type);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((searchPhrase).value = $event)),
        search
      ],
      class: "w-full border border-tile-border rounded-lg p-2 outline-none",
      placeholder: "Wyszukaj"
    }, null, 512 /* NEED_PATCH */), [
      [_vModelText, searchPhrase.value]
    ]),
    (searchItemsVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchItemsGroupedByType.value, (searchItems, type) => {
              return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", {
                  class: "text-neutral2-500 text-sm -mb-1",
                  textContent: _toDisplayString(searchItemTypeTitle(type))
                }, null, 8 /* PROPS */, _hoisted_4),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchItems, (searchItem) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("a", {
                      class: "hover:text-green2-500",
                      href: searchItem.contentHref,
                      "data-testid": "searchItem",
                      textContent: _toDisplayString(searchItem.title)
                    }, null, 8 /* PROPS */, _hoisted_6)
                  ]))
                }), 256 /* UNKEYED_FRAGMENT */))
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})